import { useEffect, useState } from 'react';
import { message } from 'antd';
import { GetAiAgentDynamicVariables } from '@/apis/settings';

type ApiDynVarItem = {
  id: string;
  label: string;
  token: string;
  is_archived?: boolean;
};
type ApiDynVarGroup = { items: ApiDynVarItem[]; is_archived?: boolean };
type ApiPayload = { all: ApiDynVarGroup[] };

type ApiResponse<T> = { data?: { data?: { data?: T } } };

export type DynVarOption = {
  key: string;
  label: string;
  token: string;
  value: string;
};

export function useDynamicVariables(token?: string | null) {
  const [options, setOptions] = useState<DynVarOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!token) return;

    setLoading(true);
    GetAiAgentDynamicVariables(token)
      .then((res) => {
        const payload = (res as unknown as ApiResponse<ApiPayload>)?.data?.data
          ?.data;

        const flat: DynVarOption[] = (payload?.all ?? [])
          .filter((g) => !g.is_archived)
          .flatMap((g) => (g.items ?? []).filter((it) => !it.is_archived))
          .map((it) => {
            const tok = String(it.token || '').trim();
            const inner =
              tok.startsWith('{') && tok.endsWith('}') ? tok.slice(1, -1) : tok;

            return {
              key: it.id,
              label: it.label,
              token: tok,
              value: inner,
            };
          });

        setOptions(flat);
      })
      .catch(() => message.error('Failed to load dynamic variables'))
      .finally(() => setLoading(false));
  }, [token]);

  return { dynVarOptions: options, dynVarLoading: loading };
}
